import { NgModule } from '@angular/core';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { DateDDMMAAAAPipe } from './date-dd-mm-aaaa.pipe';
import { ModalityPipe } from './modality.pipe';
import { DefaultValuePipe } from './default-value';

@NgModule({
  declarations: [CpfCnpjPipe, DateDDMMAAAAPipe, ModalityPipe, DefaultValuePipe],
  exports: [CpfCnpjPipe, DateDDMMAAAAPipe, ModalityPipe, DefaultValuePipe],
})
export class PipesModule {}
